import {useInfiniteQuery} from '@tanstack/react-query'
import {fetchConsultantsPreview, fetchPatientsPreview} from '@/features/mailer/http/mailer.http'
import {SendMailPayload} from '@/features/mailer/types'
import {QUERY_KEYS} from '@/queryClient'

export const usePatientsPreview = (recipients: SendMailPayload['recipients']) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.MAILER_PREVIEW, 'patients', recipients],
        queryFn: ({pageParam = 1}) => fetchPatientsPreview(recipients, pageParam),
        enabled: !!recipients.patients,
        staleTime: 0,
        gcTime: 0,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })
    return {
        ...query,
        remappedData: query.data?.pages.flatMap(p => p.data) ?? [],
        total: query.data?.pages[0]?.meta.total ?? 0
    }
}

export const useConsultantsPreview = (recipients: SendMailPayload['recipients']) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.MAILER_PREVIEW, 'consultants', recipients],
        queryFn: ({pageParam = 1}) => fetchConsultantsPreview(recipients, pageParam),
        enabled: !!recipients.consultants,
        staleTime: 0,
        gcTime: 0,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })
    return {
        ...query,
        remappedData: query.data?.pages.flatMap(p => p.data) ?? [],
        total: query.data?.pages[0]?.meta.total ?? 0
    }
}
